import { IArraySplice, intercept, IObservableArray, isArrayLike, observable } from 'mobx';

import { ClientLogger } from 'bernie-client';
import { getErrorString } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

import { STORE_EVENTS } from 'stores/events/store-events';

import { ChildModel } from './child-model';

const logger = ClientLogger.getLoggerWithIdentifier('pwa.store.roomModel');

export class RoomModel extends Store {
  constructor(state: SerializedData = {}) {
    super({}, null);

    intercept(this, 'adults', change => {
      const value = parseInt(change.newValue, 10);

      if (isNaN(value) || value < 0) {
        change.newValue = 0;
      } else {
        change.newValue = value;
      }

      return change;
    });

    intercept(this, 'children', change => {
      if (!change.newValue) {
        change.newValue = [];
      }

      change.newValue = change.newValue.map(child => {
        if (child instanceof ChildModel === false) {
          return new ChildModel(child);
        }

        return child;
      });

      return change;
    });

    // handle individual element updates from calls like replace() and push()
    intercept(this.children, (change: IArraySplice<ChildModel>) => {
      try {
        if (change.added && isArrayLike(change.added)) {
          change.added = change.added.map(item => (item instanceof ChildModel === false ? new ChildModel(item) : item));
        }
      } catch (error) {
        const changeMessage = `change.added="${typeof change.added}"`;
        const errorString = getErrorString(error);
        logger.logEvent(STORE_EVENTS.STORE_INTERCEPT_VALUE_ERROR, errorString, changeMessage);
      }

      return change;
    });

    if (typeof state === 'object' && state !== null) {
      this.children.replace(state.children);
      this.adults = state.adults;
    }
  }

  public static DEFAULTS: any = {
    adults: 0,
    children: [],
  };

  @observable
  public adults: number;
  @observable
  public children: IObservableArray<ChildModel>;

  public clone(): RoomModel {
    return new RoomModel(this.toJSON());
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public toJSON(ignoreAdditionalKeys?: string[] | string): SerializedData {
    if (!Array.isArray(ignoreAdditionalKeys)) {
      ignoreAdditionalKeys = ignoreAdditionalKeys && ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
    }
    const json = super.toJSON(ignoreAdditionalKeys.concat('children'));

    json.children = (this.children && this.children.map(child => child.toJSON())) || [];

    return json;
  }
}
